import type { AccessTemplateDto } from "@/features/identity-hub/api/identity-hub.api";
import type { OrgPickerItem } from "./OrgPickerCombobox";
import { TemplateDialog } from "./TemplateDialog";

export interface CatalogRoleDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  orgs: OrgPickerItem[];
  activeTenantId: string | null;
  editing: AccessTemplateDto | null;
}

/** Row-click / Edit catalog role — TemplateDialog body in the IAM overlay. */
export function CatalogRoleDrawer({
  open,
  onOpenChange,
  orgs,
  activeTenantId,
  editing,
}: CatalogRoleDrawerProps) {
  return (
    <TemplateDialog
      open={open}
      onOpenChange={onOpenChange}
      orgs={orgs}
      activeTenantId={activeTenantId}
      editing={editing}
      chrome="drawer"
    />
  );
}
